const isProduction = process.env.NODE_ENV === "production";

export const logger = {
    log: (...args: any[]) => {
        if (!isProduction) console.log(...args);
    },

    error: (...args: any[]) => {
        if (!isProduction) console.error(...args);
    },

    warn: (...args: any[]) => {
        if (!isProduction) console.warn(...args);
    },

    info: (...args: any[]) => {
        if (!isProduction) console.info(...args);
    },

    debug: (...args: any[]) => {
        if (!isProduction) console.debug(...args);
    },
};
